import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
type CtaButtonProps = {
  label: string;
  id?: string;
  compact?: boolean;
  shake?: boolean;
  className?: string;
};
export function CtaButton({
  label,
  id,
  compact = false,
  shake = false,
  className = ''
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta text-center font-display font-extrabold uppercase tracking-tight text-navy-950 shadow-[0_6px_0_0_#B98A00,0_14px_30px_-8px_rgba(255,209,46,0.55)] transition-[transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-1 active:shadow-[0_2px_0_0_#B98A00] focus:outline-none focus-visible:ring-4 focus-visible:ring-aqua/70 ${compact ? 'px-5 py-4 text-[15px] sm:text-base' : 'px-5 py-5 text-[17px] sm:px-7 sm:text-xl'} ${shake ? 'animate-cta-shake' : ''} ${className}`} data-id="element-11" data-mp="cj7t4ooqzlgv">
      <span className="leading-tight [text-wrap:balance]" data-id="element-12" data-mp="35xfnf4oip198">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-13" data-mp="35zin6gfh28r5" />
    </a>;
}